import { notifyMutationSuccess } from "@lib/react-query";
import type { Middleware } from "@reduxjs/toolkit";
import { isFulfilled } from "@reduxjs/toolkit";

type RtkMeta = { arg?: { type?: "query" | "mutation" } };

/**
 * Bridges RTK Query mutation successes into the same signal react-query
 * mutations emit, so the onboarding checklist can refresh derived tasks
 * without knowing which layer an action went through.
 */
export const onboardingRefreshOnMutation: Middleware =
  () => (next) => (action) => {
    const result = next(action);
    if (
      isFulfilled(action) &&
      (action.meta as RtkMeta | undefined)?.arg?.type === "mutation"
    ) {
      notifyMutationSuccess();
    }
    return result;
  };
